import _ from 'lodash';

export default {
    getNodePositions: function () {
        // TODO: Is there a better way to get the gridstack el? Will we ever have multiple '.grid-stack' els on the page?
        let gridStackEl = document.querySelector('.grid-stack');
        if (gridStackEl) {
          var gridStack = gridStackEl.gridstack;
          var nodes = gridStack.engine.nodes;
          var startNodes = [];
          _.forEach(nodes, function(node) {
            startNodes.push({ id: node.id, x: node.x, y: node.y });
          });
          return startNodes;
        }
    },

    getNodePositionsDiff: function (originals, newNode, movingNode) {
        // TODO: Is there a better way to get the gridstack el? Will we ever have multiple '.grid-stack' els on the page?
       let gridStackEl = document.querySelector('.grid-stack');
       if (gridStackEl) {
         var gridStack = gridStackEl.gridstack;
         var nodes = gridStack.engine.nodes;
         var updatedPanels = [];
         _.forEach(nodes, function(node) {
           if (originals) {
             var startNode = _.find(originals, ['id', node.id]);
             if (startNode) {
               if (startNode.x !== node.x || startNode.y !== node.y) {
                 updatedPanels.push({ id: node.id, x: node.x, y: node.y });
               }
             } else if (newNode && movingNode) {
               // this is from a drag and drop
               updatedPanels.push({ id: movingNode.id, x: node.x, y: node.y });
             } else if (!newNode && !movingNode) {
               updatedPanels.push({ id: node.id, x: node.x, y: node.y }); // if it's a new panel
             }
           } else {
             updatedPanels.push({ id: node.id, x: node.x, y: node.y }); // should never happen?
           }
         });
         return updatedPanels;
       }
    }
};
